function loadGoogleReviews() {

  const CACHE_KEY = "google_reviews_cache";
  const CACHE_TIME = 24 * 60 * 60 * 1000; // 24 hours

  const cached = localStorage.getItem(CACHE_KEY);

  if (cached) {
    const parsed = JSON.parse(cached);

    if (Date.now() - parsed.timestamp < CACHE_TIME) {
      renderReviews(parsed.data);
      return;
    }
  }

  fetch("https://backend.artstoheartsproject.com/api/users/public/reviews/")
    .then(res => res.json())
    .then(response => {

      if (!response || !response.summary) return;

      localStorage.setItem(
        CACHE_KEY,
        JSON.stringify({
          timestamp: Date.now(),
          data: response
        })
      );

      renderReviews(response);

    })
    .catch(err => console.log("Review fetch error:", err));
}


/* RENDER FUNCTION */

function renderReviews(response) {

  const rating = response.summary.average_rating;
  const total = response.summary.total_reviews;

  const ratingEl = document.getElementById("gr-rating");
  const countEl = document.getElementById("gr-count");
  const starsEl = document.getElementById("gr-stars");

  const loadingEl = document.getElementById("gr-loading");
  const wrapperEl = document.getElementById("gr-rating-wrapper");

  if (ratingEl) ratingEl.textContent = rating;
  if (countEl) countEl.textContent = total + " Reviews";

  if (starsEl) {
    const stars = "★".repeat(Math.round(rating)) + "☆".repeat(5 - Math.round(rating));
    starsEl.textContent = stars;
  }

  if (loadingEl) loadingEl.style.display = "none";
  if (wrapperEl) wrapperEl.style.display = "inline";

  const reviewList = document.getElementById("review-list");
  if (!reviewList) return;

  reviewList.innerHTML = "";

  response.data.forEach(review => {

    const stars = "★".repeat(review.rating) + "☆".repeat(5 - review.rating);

    const reviewItem = `
      <div class="review-item">

        <div class="review-header">
          <img 
            class="review-avatar" 
            src="${review.author_photo_url || ""}" 
            alt="${review.author_name}"
            width="28"
            height="28"
            loading="lazy"
          >
          
          <div>
            <strong>${review.author_name}</strong>
            <div class="review-stars">${stars}</div>
            <div class="review-time">${review.relative_time_description || ""}</div>
          </div>
        </div>

        <p class="review-text">${review.text || ""}</p>

      </div>
    `;

    reviewList.insertAdjacentHTML("beforeend", reviewItem);
  });
}


/* LOAD EVENTS */

window.addEventListener("load", loadGoogleReviews);
document.addEventListener("shopify:section:load", loadGoogleReviews);


/* MODAL HANDLING */

document.addEventListener("click", function(e) {

  const modal = document.getElementById("review-modal");
  if (!modal) return;

  if (e.target.closest("#google-review-header")) {
    modal.style.display = "flex";
    document.body.style.overflow = "hidden";
  }

  if (e.target.classList.contains("review-close")) {
    modal.style.display = "none";
    document.body.style.overflow = "auto";
  }

  if (e.target === modal) {
    modal.style.display = "none";
    document.body.style.overflow = "auto";
  }

});